var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            [
              _vm.contractPartner
                ? _c(
                    "b-card",
                    {
                      staticClass: "rounded-0 h-100",
                      attrs: {
                        title: _vm.$t("message.contractOverview.label.partner")
                      }
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.contractPartner.contractPartnerName))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.contractPartner.street) +
                            " " +
                            _vm._s(_vm.contractPartner.streetNumber)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.contractPartner.postalCode +
                                " " +
                                _vm.contractPartner.city
                            )
                        ),
                        _c("br"),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.contractPartner.postOfficeBox) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _vm.contractAddress
                ? _c(
                    "b-card",
                    {
                      staticClass: "rounded-0 h-100",
                      attrs: {
                        title: _vm.$t("message.contractOverview.label.address")
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.policyHolder.firstName +
                              " " +
                              _vm.policyHolder.lastName
                          ) +
                          "\n        "
                      ),
                      _vm.contractAddress.street
                        ? _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.contractAddress.street +
                                  " " +
                                  _vm.contractAddress.streetNumber
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contractAddress.postalCode
                        ? _c("div", [
                            _vm._v(
                              _vm._s(_vm.contractAddress.postalCode) + " "
                            ),
                            _vm.contractAddress.city
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.contractAddress.city))
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                {
                  staticClass: "rounded-0",
                  attrs: {
                    title: _vm.$t("message.contractOverview.label.info")
                  }
                },
                [
                  _c("div", { staticClass: "mb-3" }, [
                    _c("b", [_vm._v(_vm._s(_vm.contractCategoryText))])
                  ]),
                  _vm._v(" "),
                  _vm.contract.contractType
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.contractType"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.contractType) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.contractNumber
                    ? _c("div", [
                        _vm._v(
                          _vm._s(_vm.contractNumberText) +
                            ":\n          " +
                            _vm._s(_vm.contract.contractNumber) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.accountNumber
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.accountNumber"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.accountNumber) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.insuredPersonNumber
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.insuredPersonNumber"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.insuredPersonNumber) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.conclusionDate
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.conclusionDate"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm.contract.conclusionDate,
                                "DD.MM.YYYY"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.contractDuration
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.contractDuration"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.contractDuration) +
                            " " +
                            _vm._s(
                              _vm.$t(
                                "message.contractInformationForm.label.months"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.cancellationPeriod
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.cancellationPeriod"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.cancellationPeriod) +
                            "\n          " +
                            _vm._s(
                              _vm.$t(
                                "message.contractInformationForm.label.months"
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.accountUsername
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.username"
                            )
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.accountUsername) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.accountLink
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.contractInformationForm.label.link")
                          ) +
                            ":\n          " +
                            _vm._s(_vm.contract.accountLink) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.link
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.contractInformationForm.label.link")
                          ) +
                            ": " +
                            _vm._s(_vm.contract.link)
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.comment
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.contractInformationForm.label.comment"
                            )
                          ) +
                            ": " +
                            _vm._s(_vm.contract.comment) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-576915ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-576915ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractOverview.vue
// module id = t91c
// module chunks = 1